import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListEmspUserEmailCell } from './emsp-bo-invoice-list-emsp-user-email.cell';
import { EmspBoInvoiceListEmspUserEmailHeader } from './emsp-bo-invoice-list-emsp-user-email.header';

export const EmspBoInvoiceListEmspUserEmailColumn: IdentifiedColumnDef<
  EmspUserInvoiceBaseModel,
  EmspUserInvoiceBaseModel['emspUser']['email']
> = {
  id: 'emspUserEmail',
  enableSorting: false,
  header: EmspBoInvoiceListEmspUserEmailHeader,
  cell: EmspBoInvoiceListEmspUserEmailCell,
};
